
import fetch from '../utils/fetch'

// const authorizationUrl = '/api/v1/auth/hasAuthForAllOp'
// const onLoginSuccess = (loginRes, resolve, loading) => {
//   if (loginRes && loginRes.pgt) {
//     fetch({
//       url: authorizationUrl,
//       headers: { PGT: loginRes.pgt, Account: loginRes.userInfo?.account },
//       loading
//     }).then(res => {
//       if (res) {
//         resolve({
//           ...loginRes,
//           authForAllOp: res
//         })
//       } else resolve(null)
//     })
//   } else resolve(null)
// }

export default () => ({
  normalLogin (account, password, loading, onBusinessError) {
    return new Promise(resolve => {
      fetch({
        url: '/api/v1/auth/Login',
        data: {
          loginType: 'basic',
          account,
          password
        },
        loading,
        onBusinessError
      // }).then(res => onLoginSuccess(res, resolve, loading))
      }).then(res => resolve(res || null))
    })
  },
  phoneLogin (phone, code, loading) {
    return new Promise(resolve => {
      fetch({
        url: '/api/v1/auth/Login',
        data: {
          loginType: 'validate_code',
          phone,
          code
        },
        loading
      // }).then(res => onLoginSuccess(res, resolve, loading))
      }).then(res => resolve(res || null))
    })
  },
  sendValidatedCode (phone, type, onBusinessError) {
    return fetch({
      url: '/api/v1/auth/SendValidatedCode',
      data: {
        phone,
        type
      },
      onBusinessError
    })
  },
  sendEmailCode (email, type, onBusinessError) {
    return fetch({
      url: '/api/v1/auth/SendEmailCode',
      data: {
        email,
        type
      },
      onBusinessError
    })
  },
  checkMsgCode (contact, code, loading) {
    return fetch({
      url: '/api/v1/auth/CheckMsgCode',
      data: { phone: contact, code },
      loading
    })
  },
  checkEmailCode (contact, code, loading) {
    return fetch({
      url: '/api/v1/auth/CheckEmailCode',
      data: { email: contact, code },
      loading
    })
  },
  resetPassword (data, loading) {
    return fetch({
      url: '/api/v1/auth/ResetPassword',
      data,
      loading
    })
  },
  loginWithTicket (ticket, loading) {
    return new Promise(resolve => {
      fetch({
        method: 'GET',
        url: `/api/v1/auth/TicketForPgtIou?ticket=${ticket}`,
        loading
      // }).then(res => onLoginSuccess(res, resolve, loading))
      }).then(res => resolve(res || null))
    })
  }
})
